/**
 * D2 of .claude/plans/drawing-pipeline/review-and-debug/engine-debug-overlay-dev-tool-plan.md.
 *
 * Single source of truth for whether the engine-debug overlay may run at
 * all. CRA/webpack inlines both `process.env.NODE_ENV` and
 * `process.env.REACT_APP_*` at build time via DefinePlugin, so under
 * `npm run build` (NODE_ENV === 'production') this expression becomes the
 * static literal `false`. Every `if (ENGINE_DEBUG_ENABLED)` branch that
 * follows it is then unreachable dead code, which Terser strips during
 * minification — this is what makes the guard structural rather than
 * merely conditional (see the plan's §7).
 *
 * Every other engine-debug module is imported ONLY from behind this flag
 * (see DrawingViewer.jsx's lazy/gated import) so there is exactly one
 * import site to eliminate, not conditionals threaded through the viewer.
 */
export const ENGINE_DEBUG_ENABLED = (
  process.env.NODE_ENV === 'development'
  && process.env.REACT_APP_ENGINE_DEBUG === 'true'
);
